module.exports = __webpack_public_path__ + "assets/img/W1-3-F.92935114.png";